module.exports = __webpack_public_path__ + "img/banner1_1920.ffbed424.png";